import '@mantine/carousel/styles.css';
import * as Sentry from '@sentry/react';
import { SloydProvider } from '@sloyd/store-base';
import { Theme } from '@sloyd/ui';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { isLocalhost } from 'shared-base';
import { Public } from './bootstrap/App.public';
import LogsContainer from './containers/Logs.container';
import './main.bugs';
import { store } from './main.config';
import './main.scss';

const container = document.getElementById('root') ?? document.body;

const root = createRoot(container);

export const SentryErrorBoundary = Sentry.withErrorBoundary(Public, {
  onError(error) {
    // console.error('Error caught by Sentry:', error, componentStack);
    Sentry.captureException(error);
  },
  showDialog: false,
});

const Root = !isLocalhost() ? SentryErrorBoundary : Public;

root.render(
  <SloydProvider store={store}>
    <Suspense>
      <Theme>
        <Router>
          <Root />
        </Router>
        <LogsContainer />
      </Theme>
    </Suspense>
  </SloydProvider>
);
